<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['member_interests'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="d-flex justify-content-end">
              <b-alert size="small" show dismissible variant="success">
                <b>Formula &nbsp;</b>
                <hr class="mb-0 mt-1">
                <code>Payout = (Interests to Share / Total Interests) X Member Interests</code>
              </b-alert>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data Found</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(member)="data">
                  {{ data.item.member.name }} <br>
                  <b class="text-info">{{ data.item.member.member_id }}</b>
                </template>
                <template #cell(interests)="data">
                  {{ data.item.interests }}
                </template>
                <template #cell(payouts)="data">
                  {{ commas(Math.round(data.item.payouts)) }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col"><b>Total Interests : {{ commas(totalinterest) }}</b></div>
              <div class="col"><b>Total Payouts : {{ commas(Math.round(totalpayouts)) }}</b></div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Member Interests</span></center>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { memberinterestMethods, memberinterestComputed } from "@/state/helpers";

export default {
  page: {
    title: "Member Interests",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Member Interests",
      items: [{ text: "Dashboard", to: "/", }, { text: "Member Interests", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'member', label: 'Member', visible: true },
        { key: 'interests', label: 'Interests', visible: true },
        { key: 'payouts', label: 'Payout', visible: true },
      ],
    };
  },
  computed: {
    ...memberinterestComputed,
    List() { return this.memberinterests.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.memberinterests.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.memberinterests.length > 0) { a = false; } else { a = true; } return a },
    totalinterest() { var total = 0; this.memberinterests.forEach((item) => { var item_total = item.interests; total = Number(total) + Number(item_total); }); return total },
    totalpayouts() { var total = 0; this.memberinterests.forEach((item) => { var item_total = item.payouts; total = Number(total) + Number(item_total); }); return total },
  },
  mounted() {
    this.fetchMemberInterest();
    this.TotalRows = this.memberinterests.length;
    this.isBusy = false;
  },
  methods: {
    ...memberinterestMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
};
</script>